import { Route, Routes, Navigate } from "react-router";
import { RequiredPermission } from '../authentication/RequiredPermission';
import { 
    Sorteo, 
    SorteoCDEEE,
    SorteoBazar,
    AgregarEmpleadoSorteo 
} from "../pages/Sorteo";

export const RutasSorteo = () => {
    return (
        <Routes>

            <Route element={<RequiredPermission permission={['ROLE_GENERAR_SORTEO']} />}>
                <Route index element={<Sorteo />} />
                <Route path="/CDEEE" element={<SorteoCDEEE />} />
                <Route path="/Bazar" element={<SorteoBazar />} />
            </Route>

            <Route element={<RequiredPermission permission={['ROLE_VER_AREAS_ORGANIZACIONALES']} />}>
                <Route path="/agregarEmpleado" element={<AgregarEmpleadoSorteo />} />
            </Route>

            <Route path='/*' element={<Navigate to="/" replace />} />

        </Routes>
    );
};
